export class Constants {
  /// EMAILJS
  static serviceKey = "service_sewf0os";
  static publicKey = "oocLjt571FfvEaip0";
  /// TEMPLATE KEYS
  static templateKeyContactUs = "template_1jg2n9q";
  static templateKeyAppointment = "template_lz584zj";
  static templateKeyProducts = "template_f61rwqa";
  static templateApparaClub = "template_th726uf";
}
